/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Onenote_Description_1Inputs */

const en_features_onenote_description_1 = /** @type {(inputs: Features_Onenote_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heard an interesting idea? With one click, Listening will transcribe the last 2 sentences and add it to a notepad.`)
};

const es_features_onenote_description_1 = /** @type {(inputs: Features_Onenote_Description_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Escuchaste una idea interesante? Con un clic, Listening transcribirá las últimas 2 oraciones y las añadirá a un bloc de notas.`)
};

/**
* | output |
* | --- |
* | "Heard an interesting idea? With one click, Listening will transcribe the last 2 sentences and add it to a notepad." |
*
* @param {Features_Onenote_Description_1Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_onenote_description_1 = /** @type {((inputs?: Features_Onenote_Description_1Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Onenote_Description_1Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_onenote_description_1(inputs)
	return en_features_onenote_description_1(inputs)
});